module.exports = __FOREMAN_VENDOR__BRACE_EXT_SEARCHBOX__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__BRACE_EXT_SEARCHBOX__"
// module id = brace/ext/searchbox
// module chunks = 0 1 2